import { render, staticRenderFns } from "./attribute-selector.vue?vue&type=template&id=7455ce87&scoped=true"
import script from "./attribute-selector.vue?vue&type=script&lang=js"
export * from "./attribute-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7455ce87",
  null
  
)

export default component.exports